module.exports = __webpack_public_path__ + "static/media/pickup_movil.80456a3b.png";